import React from 'react';
import Header from '../../components/header';
import CookiesPolicyBody from './body';
import Footer from '../../components/footer';

function CookiesPolicy(props) {
    document.title = `Yebokenny Cookies Policy`;
    return (
        <div>
           <Header></Header> 
           <CookiesPolicyBody></CookiesPolicyBody>
           <Footer></Footer>
        </div>
    );
}

export default CookiesPolicy;